import type { CSSProperties } from "react";

/** Wrap `<Tabs.List>` in `<Box w="100%" style={NAV_TABS_FULL_WIDTH_LINE_STYLE}>` so the rule spans the full row. */
export const NAV_TABS_FULL_WIDTH_LINE_STYLE: CSSProperties = {
  borderBottom: "2px solid #04305c",
};

/** Apply to each `<Tabs.Tab>` `style` so columns match the widest tab. */
export const NAV_TAB_EQUAL_WIDTH_CELL_STYLE: CSSProperties = {
  width: "100%",
  minWidth: 0,
  justifyContent: "center",
};

/**
 * `Tabs.List` `styles`: shrink-wrapped row where every tab column matches the widest label.
 * @param columnCount Number of `<Tabs.Tab>` children in the list
 * @param listOverrides Optional extra styles for the list element (e.g. flexShrink, padding)
 */
export function navTabsListStyles(columnCount: number, listOverrides?: CSSProperties) {
  return {
    list: {
      display: "inline-grid" as const,
      gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
      width: "max-content" as const,
      maxWidth: "100%",
      alignItems: "end" as const,
      boxShadow: "none" as const,
      gap: 0,
      ...listOverrides,
    },
  };
}
